<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $t("ui.match") }}
      b-breadcrumb-item
        router-link(to="/match/match")
          i.fa.fa-gamepad
          span.ml-1 {{ $tc("ui.matches", 2) }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fas.fa-basketball-ball
                    b-form-select(v-model="sportType" autofocus)
                      //- option(value=0)
                      //-   | {{ $t("ui.all") }}
                      option(v-for="sportInfo in sportList" v-bind:value="sportInfo.sport_id")
                        | {{ sportInfo.sport_type }}
                div.col-md-4.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      i.fa.fa-search
                    DebounceInput(required type="text" v-model="matchSearch" :placeholder="$t('message.search_by_league_name')")
                div.col-md-3.mb-1
                  b-form-radio-group(
                    buttons
                    v-model="filterBy"
                    size="sm"
                    button-variant="outline-info"
                  )
                    b-form-radio(value="league_id") {{ $t("ui.league_id") }}
                    b-form-radio(value="league_name") {{ $t("ui.league_name") }}
                    b-form-radio(value="match_id") {{ $t("ui.match_id") }}
                    b-form-radio(value="home_team") {{ $t("ui.home") }}
                    b-form-radio(value="away_team") {{ $t("ui.away") }}

          div.row
            div.col-md-12.mb-1
              div.form-row
                //- div.col-md-2.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.far.fa-clock
                //-     b-form-select(v-model="marketType" @change="marketOnChange($event)")
                //-       option(value="") {{ $t('ui.all') }}
                //-       option(value="early") {{ $t('ui.early') }}
                //-       option(value="today") {{ $t('ui.today') }}
                //-       option(value="live") {{ $t("ui.live") }}
                //- div.col-md-3.mb-1
                //-   b-input-group(size="sm")
                //-     b-input-group-text(slot="prepend")
                //-       i.fas.fa-sort
                //-     b-form-select(v-model="sortKey")
                //-       option(value="match_id") {{ $t('ui.id') }}
                //-       option(value="sport_type") {{ $tc('ui.sports', 1) }}
                //-       option(value="league_name") {{ $tc("ui.leagues", 1) }}
                //-       option(value="match_date_time") {{ $t("ui.match_datetime") }}
                //-     b-form-select(v-model="sortType")
                //-       option(value="asc") {{ $t("ui.ascending") }}
                //-       option(value="desc") {{ $t("ui.descending") }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.from") }}
                    date-picker(v-model="startDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.to") }}
                    date-picker(v-model="endDate" :config="locale")
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.linked") }}
                    b-form-select(v-model="linked")
                      option(value="") {{ $t('ui.all') }}
                      option(value="true") {{ $t('ui.linked') }}
                      option(value="false") {{ $t('ui.not_linked') }}
                div.col-md-2.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="searchLeague"
                    variant="success"
                    size="sm"
                    ).mr-2
                  SubmitButton(
                    :loading="loading"
                    icon="icon-arrow-right"
                    :text="$t('ui.next')"
                    type="button"
                    @click="getLinkedMatchList(true, 'next')"
                    variant="info"
                    size="sm"
                    v-show="isShowNextBtn && pageLvl == 'league'"
                    )
          div.row
            div.col-md-12.mb-1
              div.form-row
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.short.affect_value") }}
                    b-form-select(v-model="affValue" :disabled="!isShowAffValueSave" @change="changedAffectValue(null, null, true)")
                      option(v-for="affValueInfo in affValueList" v-bind:value="affValueInfo.value")
                        | {{ affValueInfo.text }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.ldiff") }}
                    b-form-select(v-model="ldiff" :disabled="!isShowLdiffSave" @change="changedBoolValue(null, null, 'ldiff', true)")
                      option(value="true") {{ $t('ui.on') }}
                      option(value="false") {{ $t('ui.off') }}
                div.col-md-2.mb-1
                  b-input-group(size="sm")
                    b-input-group-text(slot="prepend")
                      span {{ $t("ui.is_live") }}
                    b-form-select(v-model="isLive")
                      option(value="") {{ $t('ui.all') }}
                      option(value="true") {{ $t('ui.live') }}
                      option(value="false") {{ $t('ui.non_live') }}
                //- div.col-md-2.mb-1
                //-   SubmitButton(:loading="loading" v-show="isShowAffValueSave && pageLvl == 'match'" @click="changedAffectValue(null, null, true)" icon="fa fa-save" :text="$t('ui.save')" isModal=false size="sm")
          div.row
            div.col-md-2.mb-1
              b-button(v-b-modal.createMatch type="button" variant="primary" size="sm").mr-2
                i.fa.fa-plus
                span {{ $t("ui.combine.create_match") }}
        div.card-body
          div(v-if="pageLvl == 'league'")
            div.row.clusterize
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 50%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(width=34 style="z-index: 10;")
                          span
                            input(type="checkbox" @click="rowSelect('all')" v-model="leagueAllSelected").checkbox
                        th.sticky-position(width=80)
                          span {{ $t('ui.id') }}
                        th.sticky-position(width=100)
                          span {{ $tc('ui.sports', 1) }}
                        th.sticky-position
                          span {{ $tc('ui.name', 1) }}
                    tbody.clusterize-content
                      tr(v-if="leagueList.length == 0")
                        td(colspan="4").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(item, index) in leagueList"
                        @click="rowSelect(item)"
                        :class="{ 'selectedRow' : selectedRow(item) }"
                        )
                        td
                          span
                            input(type="checkbox" v-model="item.checked" @click="rowSelect(item)").checkbox
                        td
                          span {{ item.league_id }}
                        td
                          span {{ item.sport_type }}
                        td
                          span {{ item.league_name }}
          div(v-if="pageLvl == 'match'")
            div.mb-1
              SubmitButton(
                :loading="loading"
                icon="icon-arrow-left"
                :text="$t('ui.back')"
                type="button"
                @click="backToLeagueLvl"
                variant="secondary"
                size="sm"
                ).mb-1.mr-1
            div.row
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="linkedMatchTotalRow"
                  :per-page="getMatchPageSize"
                  v-model="currentLinkedMatchPage"
                  @input="changedPage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.matchPageSizeOptions" :value="getMatchPageSize" @input="changedMatchPageSize")
                  b-input(:value="linkedMatchTotalRow" readonly)
            div.row.clusterize.mb-4
              div.col-md-12
                .clusterize-scroll
                  table.tablex(style="width: 100%;" v-columns-resizable)
                    thead
                      tr
                        th.sticky-position(width=34 style="z-index: 10;")
                          span
                            input(type="checkbox" @click="rowSelectMatch('all')" v-model="matchAllSelected").checkbox
                        th.sticky-position(width=100 @click="sortOrder('match_id')")
                          span {{ $t('ui.id') }}
                          i(:class="changeSortKey('match_id')")
                        th.text-center.sticky-position(width=60)
                          span {{ $t("ui.action") }}
                        th.sticky-position(width=80 @click="sortOrder('sport_type')")
                          span {{ $tc('ui.sports', 1) }}
                          i(:class="changeSortKey('sport_type')")
                        th.sticky-position(@click="sortOrder('league_name')")
                          span {{ $tc("ui.leagues", 1) }}
                          i(:class="changeSortKey('league_name')")
                        th.sticky-position(@click="sortOrder('home_team')")
                          span {{ $t("ui.home") }}
                          i(:class="changeSortKey('home_team')")
                        th.sticky-position(@click="sortOrder('away_team')")
                          span {{ $t("ui.away") }}
                          i(:class="changeSortKey('away_team')")
                        //- th.sticky-position(width=60)
                        //-   span(:title="$t('ui.market_type')") {{ $t("ui.short.market_type") }}
                        //- th(width=100).text-center
                        //-   span {{ $t("ui.is_live") }}
                        th.sticky-position(width=80 @click="sortOrder('match_date_time')")
                          span {{ $t("ui.short.match_date") }}
                          i(:class="changeSortKey('match_date_time')")
                        th.sticky-position(width=80)
                          span {{ $t("ui.short.match_time") }}
                        //- th(width=200)
                        //-   span {{ $t("ui.epoch_time") }}
                        th.sticky-position(width=80)
                          span {{ $t("ui.sbo") }} (1)
                        th.sticky-position(width=80)
                          span {{ $t("ui.ibc") }} (0)
                        //- th(width=100)
                        //-   span {{ $t("ui.cmd") }}
                        //- th.text-center
                        //-   span(:title="$t('ui.cmd_enabled')") {{ $t("ui.short.cmd_enabled") }}
                        th.text-center.sticky-position(width=60)
                          span(:title="$t('ui.affect_value')") {{ $t("ui.short.affect_value") }}
                        //- th.text-center
                        //-   span {{ $t("ui.semi_auto") }}
                        th.text-center.sticky-position(width=60 style="z-index: 10;")
                          span {{ $t("ui.ldiff") }}
                        //- th.text-center
                        //-   span {{ $t("ui.auto_open") }}
                        th.sticky-position(width=60)
                          span {{ $t("ui.linked") }}
                        //- th(width=30).text-center.sticky-position
                        //-   span(:title="$t('ui.mark_fetch')") {{ $t("ui.short.mark_fetch") }}
                        th(width=40).text-center.sticky-position
                          span(:title="$t('ui.swap_team')") {{ $t("ui.short.swap_team") }}
                        th(width=40).text-center.sticky-position
                          span(:title="$t('ui.manual_add')") {{ $t("ui.short.manual_add") }}
                        //- th(width=40).text-center.sticky-position
                        //-   span(:title="$t('ui.manual_map')") {{ $t("ui.short.manual_map") }}
                        //- th(width=40).text-center.sticky-position
                        //-   span(:title="$t('ui.manual_create')") {{ $t("ui.short.manual_create") }}
                        //- th(width=40).text-center.sticky-position
                        //-   span(:title="$t('ui.remap')") {{ $t("ui.short.remap") }}
                    tbody.clusterize-content
                      tr(v-if="linkedMatchList.length == 0")
                        td(colspan="16").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(
                        v-for="(item, index) in linkedMatchList"
                        :class="{ 'selectedRow' : selectedRow(item) }"
                        @click="rowSelectMatch(item, $event)"
                        )
                        td
                          span
                            input(type="checkbox" v-model="item.checked" @click="rowSelectMatch(item, $event)").checkbox
                        td.checked_selection
                          span.checked_selection
                            b-link.clickable.checked_selection(href="javascript:void(0);" @click="getMatchOddsInfo(item)") {{ item.match_id }}
                        td.actions
                          span
                            a.fa.fa-trash.text-primary(href="#" @click="onDelete(item)" :title="$t('ui.delete')")
                        td
                          span {{ item.sport_type }}
                        td
                          span(:title="item.league_name") {{ item.league_name }}
                        td
                          span(:title="item.home_team") {{ item.home_team }}
                        td
                          span(:title="item.away_team") {{ item.away_team }}
                        //- td.text-uppercase
                        //-   span {{ item.market_type }}
                        td
                          span {{ getDate(item.match_date) }}
                        //- td.text-center
                        //-   span
                        //-     i(:class="{'fas fa-check': item.is_live, 'fas fa-times': !item.is_live  }")
                        td
                          span {{ item.match_time }}
                        //- td
                        //-   span {{ item.epoch_time }}
                        td.checked_selection
                          span.checked_selection
                            b-link.clickable.checked_selection(href="javascript:void(0);" @click="getSBOOddsInfo(item)") {{ item.sbo_map }}
                        td.checked_selection
                          span.checked_selection
                            b-link.clickable.checked_selection(href="javascript:void(0);" @click="getIBCOddsInfo(item)") {{ item.ibc_map }}
                        //- td
                        //-   span {{ item.cmd_map }}
                        //- td.actions
                        //-   div.d-flex.justify-content-center.align-items-center
                        //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        //-       input.switch-input(type="checkbox" v-model="item.cmd_enabled" @change="changedBoolValue(item, $event, 'cmd_enabled')")
                        //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
                        td.checked_selection
                          //- b-form-select(v-model="item.affect_value" @change="changedAffectValue(item, $event)" size=)
                          //-   option(v-for="affValueInfo in affValueList" v-bind:value="affValueInfo.value")
                          //-     | {{ affValueInfo.text }}
                          select.checked_selection(@change="changedAffectValue(item, $event, false)" :value="getDecimal(item.affect_value)")
                            option(v-for="affValueInfo in affValueList" v-bind:value="affValueInfo.value")
                              | {{ affValueInfo.text }}
                        //- td.actions
                        //-   div.d-flex.justify-content-center.align-items-center
                        //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        //-       input.switch-input(type="checkbox" v-model="item.semi_auto" @change="changedBoolValue(item, $event, 'semi_auto')")
                        //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
                        td.actions.checked_selection
                          div.d-flex.justify-content-center.align-items-center.checked_selection
                            label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0.checked_selection
                              input.switch-input.checked_selection(type="checkbox" v-model="item.ldiff" @change="changedBoolValue(item, $event, 'ldiff', false)")
                              span.switch-slider.checked_selection(:data-checked='on' :data-unchecked='off')
                        //- td.actions
                        //-   div.d-flex.justify-content-center.align-items-center
                        //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        //-       input.switch-input(type="checkbox" v-model="item.ldiff" @change="changedBoolValue(item, $event, 'ldiff')")
                        //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
                        //- td.actions
                        //-   div.d-flex.justify-content-center.align-items-center
                        //-     label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        //-       input.switch-input(type="checkbox" v-model="item.auto_open" @change="changedBoolValue(item, $event, 'auto_open')")
                        //-       span.switch-slider(:data-checked='on' :data-unchecked='off')
                        td
                          span {{ item.link_id }}
                        //- td.text-center
                        //-   span
                        //-     i(:class="{'fas fa-check text-info': item.mark_fetch, 'fas fa-times text-warning': !item.mark_fetch  }")
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.swap_team, 'fas fa-times text-warning': !item.swap_team  }")
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.manual_add, 'fas fa-times text-warning': !item.manual_add  }")
                        //- td.text-center
                        //-   span
                        //-     i(:class="{'fas fa-check text-info': item.manual_map, 'fas fa-times text-warning': !item.manual_map  }")
                        //- td.text-center
                        //-   span
                        //-     i(:class="{'fas fa-check text-info': item.manual_create, 'fas fa-times text-warning': !item.manual_create  }")
                        //- td.text-center
                        //-   span
                        //-     i(:class="{'fas fa-check text-info': item.remap, 'fas fa-times text-warning': !item.remap  }")
            div.row
              div.col-md-12
                span.font-weight-bold {{ $t("ui.affect_value") }}
                br
                span {{ $t("message.affect_value_remark_1") }}
                br
                span {{ $t("message.affect_value_remark_2") }}
          div(v-if="pageLvl == 'odds'")
            ibcmatchinfo(@failed="handleFailed" :item="ibcInfo" v-if="oddsType == 'ibc'" @backFromOddsLvl="backFromOddsLvl")
            sbomatchinfo(@failed="handleFailed" :item="sboInfo" v-if="oddsType == 'sbo'" @backFromOddsLvl="backFromOddsLvl")
            matchinfo(@failed="handleFailed" :item="matchInfo" v-if="oddsType == 'match'" @backFromOddsLvl="backFromOddsLvl")
    creatematch(@clicked="createMatch" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import ibcmatchinfo from "@/components/match/ibcMatchInfo.vue";
import sbomatchinfo from "@/components/match/sboMatchInfo.vue";
import matchinfo from "@/components/match/matchInfo.vue";
import creatematch from "@/components/match/createMatch.vue";
import $ from 'jquery';
import {resizeColumn1} from '@/main';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    ibcmatchinfo,
    sbomatchinfo,
    matchinfo,
    creatematch
  },
  data: () => ({
    loading: false,
    ibcInfo: null,
    sboInfo: null,
    matchInfo: null,
    sportType: 1,
    sportList: [],
    linkedMatchList: [],
    currentLinkedMatchPage: 1,
    linkedMatchTotalRow: 0,
    matchSearch: "",
    marketType: "",
    sortKey: "league_name",
    sortType: "asc",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    locale: {
      format: "YYYY-MM-DD",
      useCurrent: true
    },
    affValueList: [],
    showMatchList: false,
    pageLvl: "league",
    oddsType: "",
    leagueList: [],
    linked: "",
    filterBy: "league_name",
    las: false,
    preAffValue: "0.00",
    affValue: "0.00",
    // ldiff: false,
    ldiff: true, //20250505, sky request to change filter default value to true
    matchLas: false,
    multiCheck: false,
    isLive: ""
  }),
  computed: {
    filterCache() {
      return this.$store.getters.matchCache;
    },
    getMatchPageSize() {
      return this.$store.getters.matchPageSize;
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    today() {
      return this.$moment(new Date).format('YYYY-MM-DD');
    },
    todayWD() {
      return this.$moment(new Date).add(-12, 'hours').format('YYYY-MM-DD');
    },
    tomorrowWD() {
      return this.$moment(new Date).add(1, 'days').add(-12, 'hours').format('YYYY-MM-DD');
    },
    yesterday() {
      return this.$moment(new Date).add(-1, 'days').format('YYYY-MM-DD');
    },
    leagueAllSelected:
    {
      get() {
        if (this.leagueList.length == 0)
          return false;
        else if (this.leagueList.filter(item => { return item.checked == true; }).length == this.leagueList.length)
          return true;
        else if (this.las)
          return this.las;
        else
          return false;
      },
      set(value) {
        this.las = value;
      }
    },
    matchAllSelected:
    {
      get() {
        if (this.linkedMatchList.length == 0)
          return false;
        else if (this.linkedMatchList.filter(item => { return item.checked == true; }).length == this.linkedMatchList.length)
          return true;
        else if (this.matchLas)
          return this.matchLas;
        else
          return false;
      },
      set(value) {
        this.matchLas = value;
      }
    },
    isShowNextBtn() {
      if (this.leagueList.filter(item => { return item.checked == true; }).length > 0)
        return true;

      return false;
    },
    isShowAffValueSave() {
      if (this.linkedMatchList.filter(item => { return item.checked == true; }).length > 0)
        return true;

      return false;
    },
    isShowLdiffSave() {
      if (this.linkedMatchList.filter(item => { return item.checked == true; }).length > 0)
        return true;

      return false;
    }
  },
  mounted: function() {
    this.getAffectValueList();
    this.getSportList();
    // this.startDate = this.yesterday;
    // this.endDate = this.today;
    this.sportType = this.filterCache.sport;
    this.linked = this.filterCache.linked;
    this.isLive = this.filterCache.isLive;
    this.marketType = this.filterCache.market;
    this.filterBy = this.filterCache.filterBy;
    this.matchSearch = this.filterCache.matchSearch;
    this.startDate = this.filterCache.startDate;
    this.endDate = this.filterCache.endDate;
    resizeColumn1();
  },
  methods: {
    getMatchInfo(item) {
      return "<span class='fas fa-check text-info'></span>";
    },
    marketOnChange(eventStatus) {
      if (eventStatus == '') {
        this.startDate = this.yesterday;
        this.endDate = this.today;
      }
      else if (eventStatus == 'early') {
        this.startDate = this.tomorrowWD;
        this.endDate = this.tomorrowWD;
      } else if (eventStatus == 'today' || eventStatus == 'live') {
        this.startDate = this.todayWD;
        this.endDate = this.todayWD;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLinkedMatchList(true, 'search');
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    getDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
    showTooltip: function(e) {
      if (e.srcElement.offsetWidth < e.srcElement.scrollWidth) {
        e.srcElement.title = e.srcElement.innerText;
      }
    },
    changedFilterCache: function() {
      var json = {
        sport: this.sportType,
        matchSearch: this.matchSearch,
        linked: this.linked,
        isLive: this.isLive,
        market: this.marketType,
        filterBy: this.filterBy,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.$store.dispatch("layout/setMatchCache", json);
    },
    searchLeague() {
      this.leagueAllSelected = false;
      this.leagueList = [];
      this.changedFilterCache();
      if (this.filterBy == 'match_id' || this.filterBy == 'home_team' || this.filterBy == 'away_team')
        this.getLinkedMatchList(true, 'search');
      else
        this.getleagueList();
    },
    getleagueList: function() {
      this.pageLvl = "league";

      let url = config.matchLeagueListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        linked: this.linked == '' ? null : this.linked,
        is_live: this.isLive == '' ? null : this.isLive,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD")
        // sort_key: this.sortKey,
        // sort_type: this.sortType
      };

      if (this.filterBy == "league_id") {
        json.league_id = this.matchSearch;
      } else if (this.filterBy == "league_name") {
        json.league_name = this.matchSearch;
      }

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.leagueList = response.data.tbl_match_league_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    selectedRow: function(info) {
      if (info.checked)
        return true;

      return false;
    },
    rowSelect: function(leagueInfo) {
      if(leagueInfo != "all") {
        setTimeout(() => {
          this.leagueList.filter(item => {
            return item.league_id == leagueInfo.league_id
          }).map(function(x) {
            x.checked = !x.checked;
            return x;
          });
        }, 10);
      }
      else {
        setTimeout(() => {
          if (this.las) {
            this.leagueList.map(function(x) {
              x.checked = true;
              return x;
            });
          } else {
            this.leagueList.map(function(x) {
              x.checked = false;
              return x;
            });
          }

        }, 10);
      }
    },
    rowSelectMatch: function(matchInfo, ev) {
      if(matchInfo != "all") {
        setTimeout(() => {
          this.linkedMatchList.filter(item => {
            return item.match_id == matchInfo.match_id
          }).map(function(x) {
            if($(ev.target).hasClass('checked_selection')) {
              if(!x.checked) x.checked = true;
            }
            else {
              x.checked = !x.checked;
            }
            return x;
          });
        }, 10);
      }
      else {
        setTimeout(() => {
          if (this.matchLas) {
            this.linkedMatchList.map(function(x) {
              x.checked = true;
              return x;
            });
          } else {
            this.linkedMatchList.map(function(x) {
              x.checked = false;
              return x;
            });
          }

        }, 10);
      }
    },
    getMatchOddsInfo: function(item) {
      this.matchInfo = item;
      this.pageLvl = "odds";
      this.oddsType = "match";
      // this.$refs.matchInfo.$refs.matchInfoModal.show();
    },
    getIBCOddsInfo: function(item) {
      this.ibcInfo = item;
      this.pageLvl = "odds";
      this.oddsType = "ibc";
      // this.$refs.ibcMatchInfo.$refs.ibcMatchInfoModal.show();
    },
    getSBOOddsInfo: function(item) {
      this.sboInfo = item;
      this.pageLvl = "odds";
      this.oddsType = "sbo";
      // this.$refs.sboMatchInfo.$refs.sboMatchInfoModal.show();
    },
    changedBoolValue: function(item, eventStatus, prop, multiSelect) {
      var tempList = this.linkedMatchList.filter(item => { return item.checked == true; });

      this.$helpers
        .alert({
          title: this.$t("ui." + prop),
          text: this.$t("message.change_batch_ldiff_confirm"),
          // text: this.$t("message.change_" + prop + "_confirm", { name: item.match_id }),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            var value = false;
            if(!multiSelect) value = eventStatus.srcElement.checked;
            this.confirmBoolValue(item, value, prop, multiSelect, tempList);
          } else {
            if(!multiSelect) eventStatus.srcElement.checked = !item[prop];
          }
        });
    },
    confirmBoolValue: function(item, status, prop, multiSelect, tempList) {
      let url = "";

      if (prop == "cmd_enabled") url = config.editMatchCMDEnabledUrl();
      else if (prop == "semi_auto") url = config.editMatchSemiAutoUrl();
      else if (prop == "ldiff") url = config.editMatchLdiffUrl();
      else if (prop == "auto_open") url = config.editMatchAutoOpenUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
      };

      if(!multiSelect) {
        json.match_id_str = item.match_id + '';
        json[prop] = status;
      }
      else {
        var list = [];
        for(var i = 0; i < tempList.length; i++) {
          list.push(tempList[i].match_id);
        }
        json.match_id_str = list.join(', ');
        json[prop] = this.ldiff;
      }

      this.feedback.success = true;
      // this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          // this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(!multiSelect)
                  item[prop] = status;
                // this.$helpers.showDialog(this.$t("ui." + prop), this.$t("message.success"), "success");
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList(true, 'search');
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    changedAffectValue: function(affValue, eventStatus, multiSelect) {
      var tempList = this.linkedMatchList.filter(item => { return item.checked == true; });

      this.$helpers
        .alert({
          title: this.$t("ui.affect_value"),
          // text: this.$t("message.change_affect_value_confirm", { name: affValue.match_id }),
          text: this.$t("message.change_batch_affect_value_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            var value = '0.00';
            if(!multiSelect) value = eventStatus.srcElement.value;
            this.confirmAffectValue(affValue, value, multiSelect, tempList);
          } else {
            if(!multiSelect)
              eventStatus.srcElement.value = parseFloat(affValue.affect_value).toFixed(2);
            else
              this.affValue = this.preAffValue;
          }
        });
    },
    confirmAffectValue: function(affValue, value, multiSelect, tempList) {
      let url = config.updateMatchAffectValueUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch
      };
      if(!multiSelect) {
        json.match_id_str = affValue.match_id + '';
        json.affect_value = value;
      }
      else {
        var list = [];
        for(var i = 0; i < tempList.length; i++) {
          list.push(tempList[i].match_id);
        }
        json.match_id_str = list.join(', ');
        json.affect_value = this.affValue;
      }

      this.feedback.success = true;
      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                if(!multiSelect)
                  affValue.affect_value = value;
                else
                  this.preAffValue = this.affValue;
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList(true, 'search');
                // this.$helpers.showDialog(this.$t("ui.affect_value"), this.$t("message.success"), "success");
              } else {
                // this.$helpers.handleFeedback(this.feedback.status);
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getAffectValueList: function() {
      for (var i = 0.0; i <= 1.0; i += 0.1) {
        this.affValueList.push({
          value: parseFloat(i).toFixed(2),
          text: i.toFixed(2)
        });
      }
    },
    getDate(dateTime) {
      let convertDateFormat = this.$moment(dateTime).format("YYYY-MM-DD");
      return convertDateFormat;
    },
    getSportList: function() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getLinkedMatchList: function(isSearch, type) {
      this.pageLvl = "match";

      let url = config.matchListUrl();

      // reset current page to 1 when "Search" button is clicked..
      if (isSearch) this.currentLinkedMatchPage = 1;

      var list = [];
      var tempList = this.leagueList.filter(item => { return item.checked == true; });

      for(var i = 0; i < tempList.length; i++) {
        list.push(tempList[i].league_id);
      }

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        sport_id: this.sportType,
        market_type: this.marketType,
        match_date_from: this.$moment(this.startDate).format("YYYY-MM-DD"),
        match_date_to: this.$moment(this.endDate).format("YYYY-MM-DD"),
        league_id_str: list.join(', '),
        linked: this.linked == '' ? null : this.linked,
        is_live: this.isLive == '' ? null : this.isLive,
        sort_key: this.sortKey,
        sort_type: this.sortType,
        page_number: this.currentLinkedMatchPage,
        page_size: this.getMatchPageSize,
        pagination: true
      };

      if (this.filterBy == "match_id" && type == 'search') {
        json.match_id = this.matchSearch;
      } else if (this.filterBy == "home_team" && type == 'search') {
        json.home_team = this.matchSearch;
      } else if (this.filterBy == "away_team" && type == 'search') {
        json.away_team = this.matchSearch;
      }

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.linkedMatchList = response.data.tbl_match_list;
                this.linkedMatchTotalRow = this.linkedMatchList.length > 0 ? this.linkedMatchList[0].totalrows : 0;
                this.matchAllSelected = false;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    createMatch: function() {
      this.$helpers.showDialog(this.$t("ui.combine.create_match"), this.$t("message.success"), "success");
    },
    changedPageSize: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentLinkedMatchPage = 1;
      this.getLinkedMatchList(false, 'search');
    },
    changedMatchPageSize: function(pageSize) {
      this.$store.dispatch("layout/setMatchPageSize", pageSize);
      this.currentLinkedMatchPage = 1;
      this.getLinkedMatchList(false, 'search');
    },
    changedPage: function(pageNo) {
      this.currentLinkedMatchPage = pageNo;
      this.getLinkedMatchList(false, 'search');
    },
    backToLeagueLvl() {
      this.pageLvl = "league";
    },
    backFromOddsLvl() {
      this.pageLvl = "match";
      this.oddsType = "";
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    },
    toggleMultiCheck(){
      this.multiCheck = !this.multiCheck;
      if(this.multiCheck == true){
        $('body').addClass('overflow-hidden');
        // $('.clusterize-scroll').addClass('overflow-hidden');
      }else{
        $('body').removeClass('overflow-hidden');
        // $('.clusterize-scroll').removeClass('overflow-hidden');
      }
    },
    matchBatchUpdate(event, option){
      if(this.linkedMatchList.length > 0){
        var item = {};
        var matchList = "";
        for (var i = 0; i < this.linkedMatchList.length; i++){
          if(this.linkedMatchList.length - i == 0){
            matchList += this.linkedMatchList[i].match_id
          }else{
            matchList += this.linkedMatchList[i].match_id+", ";
          }
        }
        item.match_id = matchList;
        if(option == 'check'){
          this.confirmBoolValue(item, true, 'ldiff');
        }else{
          this.confirmBoolValue(item, false, 'ldiff');
        }
        this.multiCheck = false;
      }
    },
    onDelete(item) {
      this.purgeMatch(item);
    },
    purgeMatch: function(item) {
      this.$helpers
        .alert({
          title: this.$t("ui.purge_match"),
          text: this.$t("message.purge_match_confirm"),
          type: "question",
          showCancelButton: true
        })
        .then(result => {
          if (result.value) {
            this.confirmPurgeMatch(item);
          }
        });
    },
    confirmPurgeMatch(item) {
      let url = config.purgeMatchUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.linkedmatch,
        match_id: item.match_id,
        link_id: item.link_id
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.$snotify.success(this.$t("message.success"));
                this.getLinkedMatchList(true, 'search');
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
  }
};
</script>
<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
.custom-modal{
  position: fixed;
  z-index: 10;
  left: 0px;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: black;
  background-color: rgba(0, 0, 0, 0.4);
  margin-top: 9px;
}
.button-box{
  position: fixed;
  z-index: 999;
  background-color: #e8e8e8;
}
.pop-up-modal{
  height: auto;
  width: auto;
}
.custom-min-height01{
  min-height: 20vh;
}
</style>